import { Title3, Body } from "../text";
import { Box, Flex } from "rebass/styled-components";
import styled from "styled-components";
import { MatchHistoryWidget } from "../../MVVM/Views/MatchHistory/MatchHistoryWidget";

const Wrapper = styled(Box)`
  position: relative;
  text-align: left;
  background-color: ${(props) => {
    return props.theme.colors.transparent;
  }};
  border-top: 2px solid
    ${(props) => {
      return props.theme.colors.navy;
    }};
  padding-top: 0px;
  padding-bottom: 25px;
  padding-left: 25px;
  padding-right: 25px;
  min-height: 700px;
`;

const StyledBody = styled(Body)`
  max-width: 540px;
  text-align: center;
`;

const StyledTitle3 = styled(Title3)`
  font-weight: 600;
`;

export function ContentAnnouncement({ title, svg, isOwnProfile }) {
  return (
    <Wrapper>
      <Flex alignItems={"center"} justifyContent="center" mb={8} mt={6}>
        <Flex
          flexDirection={"column"}
          justifyContent="center"
          alignItems="center"
        >
          {svg}
          <StyledTitle3 my={3}>{title}</StyledTitle3>
          <StyledBody color="chalk">
            But with the magic of Allstar you can start creating right now.
            We've added some of your most recent moments below, just click
            create and a clip will land on your profile in no time!
          </StyledBody>
        </Flex>
      </Flex>

      <MatchHistoryWidget />
    </Wrapper>
  );
}
